<template>
    <div>
        <div class="container-fluid">
            <div class="success_message" v-text="this.$root.success_message" v-if="this.$root.success_message != ''">
            </div>
            <div class="error_message" v-text="this.$root.error_message" v-if="this.$root.error_message != ''"></div>
            <div class="row">
                <div class="col-12">
                    <div class="row " v-if="mobile_view==false">
                        <div class="col-4 p-0 text-center">
                            <img src="/images/result/trenmain_d3.jpg" class="w-100" style="max-width: 450px;">
                        </div>
                        <div class="col-8 trendsetter_bg">
                            <div class="content-box">
                                <h2>Trendsetter</h2>
                                <p>You are spontaneous and innovative, always looking for something new. You do not want to blend in, but make a statement through your style. A pioneer when it comes to being the first one to show people how to wear it right, you don’t believe in waiting. Why follow when you can lead! Signs of a true boss lady!                                </p>

                                <div class="bottom-content text-center">
                                    <a href="#wordrobe-product">
                                        <h3 class="zoom_animation"><strong>Weeble suggests....</strong></h3>
                                    </a>
                                    <!--p class="share">Share your results</p>
                                <div class="share-icon" id="wordrobe"><a href="#" class="fa fa-facebook"></a><a href="#"
                                        class="fa fa-instagram"></a></div-->
                                    <h3>Your Trend Colour -  Indigo Blue</h3>
                                    <div class="color">
                                        <li class="blue"></li>
                                        <li class="green"></li>
                                        <li class="sky-blue"></li>
                                        <li class="grey"></li>
                                    </div>
                                    <h3>Your Trend Pick -  Fashion Co-ordinates</h3>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="mobile_view==false">
                        <div class="col-12">
                            <div class="container">
                                <div class="product-section text-center">
                                    <h2><img src="/images/result/bee.jpg" style="margin-top: -15px;margin-right:10px;">Weeble's wardrobe edits for you!</h2>
                                </div>
                                <div class="slider text-center robe-slider">
                                    <slick ref="slickevery" :options="slickOptions" @afterChange="handleAfterChange">
                                        <div class="pro-box" v-for="(article,index) of wardrobeitem" @click.prevent="wardproduct(index)">
                                            <img src="/images/wordrobe/trendsetter3.jpg" v-if="article[0]=='Boho Love'" class="w-100">
                                            <img src="/images/wordrobe/trendsetter1.jpg" v-if="article[0]=='Runway Picks'" class="w-100">
                                            <img src="/images/wordrobe/trendsetter2.jpg" v-if="article[0]=='In Vogue'" class="w-100">
                                            <p>{{article[0]}}</p>
                                        </div>
                                    </slick>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="mobile_view==true">
                        <div class="col-12 page-2">
                            <img src="/images/result/trenmainnew1.jpg" class="w-100">
                            <div class="content-box trendsetter">
                                <h2>Trendsetter</h2>
                                <p>You are spontaneous and innovative, always looking for something new. You do not want to blend in, but make a statement through your style. A pioneer when it comes to being the first one to show people how to wear it right, you don’t believe in waiting. Why follow when you can lead! Signs of a true boss lady!                                </p>
                                <a href="#wordrobe-product">
                                    <p class="zoom_animation"><strong>Weeble suggests....</strong></p>
                                </a>
                                <!--p class="share">Share your results</p>
                                <div class="share-icon" id="wordrobe"><a href="#" class="fa fa-facebook"></a><a href="#"
                                        class="fa fa-instagram"></a></div-->
                            </div>
                            <div class="bottom-content text-center">
                                <h3>Your Trend Colour -  Indigo Blue</h3>
                                <div class="color">
                                    <li class="blue"></li>
                                    <li class="green"></li>
                                    <li class="sky-blue"></li>
                                    <li class="grey"></li>
                                </div>
                                <h3>Your Trend Pick -  Fashion Co-ordinates</h3>
                            </div>
                            <div class="product-section text-center">
                                <h2><img src="/images/result/bee.jpg" style="margin-top: -15px;margin-right:10px;">Weeble's wardrobe edits for you!</h2>
                            </div>
                            <div class="slider text-center robe-slider">
                                <slick ref="slickevery" :options="slickOptions" @afterChange="handleAfterChange">
                                    <div class="pro-box" v-for="(article,index) of wardrobeitem" @click.prevent="wardproduct(index)">
                                        <img src="/images/wordrobe/trendsetter3.jpg" v-if="article[0]=='Boho Love'" class="w-100">
                                        <img src="/images/wordrobe/trendsetter1.jpg" v-if="article[0]=='Runway Picks'" class="w-100">
                                        <img src="/images/wordrobe/trendsetter2.jpg" v-if="article[0]=='In Vogue'" class="w-100">
                                        <p>{{article[0]}}</p>
                                    </div>
                                </slick>
                            </div>
                        </div>
                    </div>
                    <div class="container product-section-main wordrobe-product" id="wordrobe-product" v-if="this.weeble.society_name==''">
                        <h3 class="text-center mb-4">Explore this wardrobe to mix & match these amazing pieces and create<br> unlimited fashion looks.</h3>
                        <div class="row  product-list">
                            
                            <div class="col-sm-6 col-xs-6 col-6 pl-1 pr-1"  v-for="(article,index) of activerobeproducts" v-bind:class="{'col-md-3 pt-6':index==0||index==4, 'col-md-2':index==1||index==2||index==3||index==6||index==7||index==8, 'm-top-150':index==6||index==7||index==8, 'pt-5':index==7||index==2}" v-if="index!=5">
                                <div class="slide-box" :index="index">
                                    <div class="product-box">
                                        <router-link
                                            :to="{name:'detail', params:{ pro_id: article[1].id_product , pro_url_key:article[1].url_key}}">
                                            
											 <responsive-image
            
											v-bind:desktop="`${$root.image_url_c}inside/900x450/${article[1].image}`"
											v-bind:tab="`${$root.image_url_c}inside/600x280/${article[1].image}`"
											v-bind:mobile="`${$root.image_url_c}inside/650x280/${article[1].image}`"
											v-bind:default_image="`${$root.image_url_c}inside/800x250/${article[1].image}`"
										  
												
										/>

                                        </router-link>
                                        <div class="wordrobe-content">
                                            <a href="#" @click.prevent="addtocart(index)" class="view-detail">Add to Cart</a>
                                            <p><router-link
                                                :to="{name:'detail', params:{ pro_id: article[1].id_product , pro_url_key:article[1].url_key}}">{{article[1].name}}</router-link></p>
                                                    <div class="price" v-if="article[1].selling_price != article[1].price">
                                                        <p><span class="old-price" >{{article[1].price | formatMoney}}</span> <span
                                                                class="price" >{{article[1].selling_price | formatMoney}}</span> <span
                                                                class="discount_percent font-bold" v-if="article[1].product_type==null">{{ $root.percentOff(article[1].price,article[1].selling_price)}}</span>
                                                        </p>
                                                    </div>
                                                    <div class="price" v-else>
                                                        <p><span class="price" >{{article[1].selling_price | formatMoney}}</span></p>
                                                    </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-6 col-6 blank" v-else></div>
                        </div>
                    </div>
                    <div class="row" v-if="this.weeble.society_name!=''">
                       <div class="col-12 text-center mt-5">
                           <h1 class="font-bold mb-4">Hey, we are coming</br> to your society</h1>
                           <p style="font-size:25px;"><span class="font-bold">{{this.weeble.society_name}}</span> on <span class="font-bold">{{this.weeble.event_date}}.</span><br> Book your exclusive slots with us to explore </br>specially curated wardrobes for YOU.</p>
                           <form class="word-form" @submit="this.book_slot">
                              <input type="text" v-model="weeble.name" @keyup="user_name" required placeholder="Name*">
                              <p class="size_error text-left" v-if="name_error!=''" style="margin-top:-10px;">{{name_error}}</p>
                              <input type="text" v-model="weeble.phone" @keyup="edit_phone" required placeholder="Phone Number*" maxlength="10">
                              <p class="size_error text-left" v-if="phone_error!=''" style="margin-top:-10px;">{{phone_error}}</p>
                              <select v-model="weeble.slot">
                                <option value="">Slots</option>
                                <option value="11.00 AM to 2.00 PM">11.00 AM to 2.00 PM</option>
                                <option value="2.00 PM to 5.00 PM">2.00 PM to 5.00 PM</option>
                                <option value="5.00 PM to 6.00 PM">5.00 PM to 8.00 PM</option>
                              </select>
                              <button type="submit">Book Slot</button>
                           </form>
                       </div>
                    </div>
                </div>
                <div class="product-detail-container" v-if="size_popup==true&&this.$route.query.popup==true">
                    <div class="size-container" v-bind:class="{active:size_popup==true}">
                        <div class="popup-box">
                        <div class="size-bg">
                            <div class="close" @click="size_close"><i class="fa fa-times"></i></div>
                            <label>Select Size</label>
                            <div class="size-box">
                                <label class="size select-one-size" v-for="items in variation[0]" @click="select_size"
                                    v-bind:class="{ disabled: items.quantity <= '0', selected: size.select_size === items.configrable_atribute_value}">
                                    <input type="radio" v-model="size" name="size"
                                        :value="{select_size:items.configrable_atribute_value, max_qty:items.quantity, variant_id:items.id_product, sku:items.sku}"
                                        v-bind:disabled="(items.quantity <= '0' ) === true"><span
                                        v-text="items.configrable_atribute_value"></span>
                                </label>
                                <p class="section_error">{{size_error}}</p>
                            </div>
                        </div>
                        <div class="add-to-cart-container">
                            <div class="add-to-cart-btns">
                                <button type="button" v-ripple class="add-to-cart btn" id="product-addtocart-button"
                                    title="Add to cart" @click="add_to_cart($event)">Add to cart</button>
                                <button type="button" v-ripple class="buy-now btn" id="buy-now" title="Buy now"
                                    @click="add_to_cart($event)">Buy Now</button>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
	@import "../../node_modules/slick-carousel/slick/slick.css";
</style>
<script>
	import Slick from "vue-slick";
	import axios from "axios";
	 
	export default {
		metaInfo() {
			return {
				title: this.meta_title,
				meta: [
					{
						name: "description",
						content: this.meta_description,
					},
					{
						property: "keywords",
						content: this.meta_keyword,
					},
				],
			};
		},
		name: "trendsetter",
		components: {
			Slick, 
		},
		data() {
			return {
				variation: [],
				size_active: true,
				size_error: "",
				wardrobeitem: [],
				pro_id: "",
				name: "",
				master_sku: "",
				price: "",
				final_price: "",
				qty: "",
				size: {
					select_size: "",
					max_qty: "1",
					variant_id: "",
					sku: "",
				},
				size_popup: false,
				meta_title: "",
				meta_description: "",
				meta_keyword: "",
				personality: "",
				wardrobeitem: [],
				activerobe: "",
				activerobeproducts: [],
				mobile_view: false,
				slickOptions: {
					infinite: false,
					centerMode: true,
					centerPadding: "31%",
					arrows: false,
					focusOnSelect: true,
					initialSlide: 1,
					slidesToShow: 1,
				},
				phone_error: "",
				name_error: "",
				weeble: {
					society_name: "",
					event_date: "",
					name: "",
					phone: "",
					slot: "",
				},
			};
		},
		beforeMount() {
			if (this.$route.query.sort_code && this.$route.query.sort_code != "") {
				this.weeble_list();
			}
			axios
				.get(
					this.$root.api_url +
						`/pim/pimresponse.php?service=personality_wardrobe&personality_name=Trendsetter&store=1`
				)
				.then((response) => {
					var result = Object.entries(response.data.result.wardrobe);
					this.wardrobeitem = result;
					this.activerobe = this.wardrobeitem[1][0];
					var robeproducts = Object.entries(this.wardrobeitem[1][1]);
					//this.activerobeproducts =
					for (let i = 0; i < robeproducts.length; i++) {
						if (i == 5) {
							this.activerobeproducts.push([i]);
						}
						this.activerobeproducts.push(robeproducts[i]);
					}
					let currIndex1 = this.$refs.slickevery.currentSlide();
					this.$refs.slickevery.destroy();
					this.$nextTick(() => {
						this.$refs.slickevery.create();
						this.$refs.slickevery.goTo(currIndex1, true);
					});
				});
		},
		methods: {
			user_name: function () {
				var name = /^(?!\s*$).+/;
				if (this.weeble.name.match(name)) {
					this.name_error = "";
				} else {
					this.name_error = "Please enter valid Name";
				}
			},
			edit_phone: function () {
				var phoneno = /^([0-9]{10,})+$/;
				if (this.weeble.phone.match(phoneno)) {
					this.phone_error = "";
				} else {
					this.phone_error = "Please enter valid Phone Number";
				}
			},
			book_slot(e) {
				e.preventDefault();
				if (
					this.weeble.name != "" &&
					this.weeble.phone != "" &&
					this.name_error == "" &&
					this.phone_error == ""
				) {
					this.$root.page_loader = true;
					axios
						.get(this.$root.api_url + `/pim/pimresponse.php`, {
							params: {
								service: "society_participant_list",
								store: this.$root.store,
								name: this.weeble.name,
								phone_number: this.weeble.phone,
								slot: this.weeble.slot,
								society_name: this.weeble.society_name,
								event_date: this.weeble.event_date,
							},
						})
						.then((response) => {
							this.$root.page_loader = false;
							if (response.data.response.success == 1) {
								this.weeble.name = "";
								this.weeble.phone = "";
								this.weeble.slot = "";
								this.$toast.success("Thank you for Booking.", {
									position: "top",
									duration: 4000,
								});
							}
						})
						.catch((error) => {
							this.$root.page_loader = false;
							if (error.message === "Network Error") {
								this.$toast.error(
									"Oops there seems to be some Network issue, please try again.",
									{
										position: "top",
										duration: 4000,
									}
								);
							}
						});
				} else {
					this.user_name();
					this.edit_phone();
				}
			},
			weeble_list() {
				axios
					.get(
						this.$root.api_url +
							`/pim/pimresponse.php?service=society_list&store=1&sort_code=${this.$route.query.sort_code}`
					)
					.then((response) => {
						this.weeble.society_name = response.data.result[0].name;
						this.weeble.event_date = response.data.result[0].event_date;
					});
			},
			handleAfterChange(event, slick, currentSlide) {
				this.activerobeproducts = [];
				this.activerobe = this.wardrobeitem[currentSlide][0];
				var robeproducts = Object.entries(this.wardrobeitem[currentSlide][1]);
				//this.activerobeproducts =
				for (let i = 0; i < robeproducts.length; i++) {
					if (i == 5) {
						this.activerobeproducts.push([i]);
					}
					this.activerobeproducts.push(robeproducts[i]);
				}
				jQuery("html, body").scrollTop(
					jQuery("#wordrobe-product").offset().top - 300
				);
			},
			add_to_cart: function (event) {
				this.$root.cart_id = $cookies.get(
					window.location.hostname.substring(10, 4) + "_cart"
				);
				if (this.size.select_size != "") {
					this.$root.page_loader = true;
					var form = new FormData();
					form.append("product_id", this.size.variant_id);
					form.append("product_parent_id", this.pro_id);
					form.append("product_options", this.size.select_size);
					form.append("name", this.name);
					form.append("sku", this.size.sku);
					form.append("master_sku", this.master_sku);
					form.append("price", this.price);
					form.append("qty_ordered", this.qty);
					form.append("final_price", this.final_price);
					form.append("store", this.$root.store);
					if (this.$root.cart_id != null && this.$root.cart_id != "") {
						form.append("cart_id", this.$root.cart_id);
						form.append("cart_session", this.$root.cart_session);
					}
					if (this.$root.customer_id != null && this.$root.customer_id != "") {
						form.append("customer_id", this.$root.customer_id);
						form.append("customer_session", this.$root.customer_session);
					}
					let config = { headers: { "Content-Type": "multipart/form-data" } };
					axios
						.post(this.$root.cart_api + "/product/add-product", form, config)
						.then((response) => {
							if (response.data.success === true) {
								this.$root.success_message = response.data.message;
								this.$root.error_message = "";
								this.$root.page_loader = false;
								this.$root.cart_product = response.data.data.products;
								this.$root.cart_total = response.data.data.grand_total;
								this.$root.cart_subtotal = response.data.data.order_subtotal;
								this.$root.discount_code = response.data.data.discount_code;
								this.$root.discount_amount = response.data.data.discount_amount;
								this.$root.address = response.data.data.address;
								if (this.$root.address.length != 0) {
									for (let i = 0; i < this.$root.address.length; i++) {
										if (i == 0) {
											this.$root.address_id = this.$root.address[i].id * 1;
											this.$root.select_address_no = i;
										}
									}
								}
								$cookies.set(
									window.location.hostname.substring(10, 4) + "_cart",
									response.data.data.cart_id
								);
								if (response.data.data.cart_session) {
									$cookies.set(
										window.location.hostname.substring(10, 4) + "_carts",
										response.data.data.cart_session,
										"1y"
									);
									this.$root.cart_session = response.data.data.cart_session;
								}
								this.$root.cart_id = response.data.data.cart_id;
								this.$root.thankyou_cart = response.data.data.cart_id;
								if (event.target.title === "Buy now") {
									this.$gtm.trackEvent({
										event: "addToCart",
										category: "Ecommerce",
										action: "Buy_now",
										label: this.name,
										ecommerce: {
											currencyCode: "INR",
											add: {
												product: [
													{
														name: this.name,
														id: this.master_sku,
														price: this.selling_price,
														variant: this.size.select_size,
														quantity: this.qty,
														category: this.product_cat,
													},
												],
											},
										},
									});
									setTimeout(
										() =>
											this.$gtm.trackEvent({
												event: "checkout",
												category: "Ecommerce",
												action: "Buy_now",
												label: "1",
												ecommerce: {
													checkout: {
														actionField: {
															step: 1,
															option: this.$root.login_status,
														},
														product: this.$root.gtm_product,
													},
												},
											}),
										100
									);

									this.$router.push("checkout.html");
								} else {
									window.scrollTo(0, 0);
									this.size_popup = false;
									this.$root.minicart = false;
									this.size_active = true;
									this.$gtm.trackEvent({
										event: "addToCart",
										category: "Ecommerce",
										action: "Add_to_cart",
										label: this.name,
										ecommerce: {
											currencyCode: "INR",
											add: {
												product: [
													{
														name: this.name,
														id: this.master_sku,
														price: this.selling_price,
														variant: this.size.select_size,
														quantity: this.qty,
														category: this.product_cat,
													},
												],
											},
										},
									});
								}

								this.size.select_size = "";
							} else {
								this.$root.success_message = "";
								this.$root.error_message = response.data.message;
								this.$root.page_loader = false;
								if (
									response.data.cart_session_status == false ||
									response.data.customer_session_status == false
								) {
									$cookies.set(
										window.location.hostname.substring(10, 4) + "_cart",
										"",
										"1y"
									);
									$cookies.set(
										window.location.hostname.substring(10, 4) + "_carts",
										"",
										"1y"
									);
									this.$root.cart_id = "";
									this.$root.cart_session = "";
									this.$root.cart_product = [];
									$cookies.set(
										window.location.hostname.substring(10, 4) + "_customer",
										"",
										"1y"
									);
									$cookies.set(
										window.location.hostname.substring(10, 4) + "_cs",
										"",
										"1y"
									);
									this.$root.customer_id = "";
									this.$root.customer_session = "";
								}
							}
						})
						.catch((error) => {
							this.$root.page_loader = false;
							this.$root.error_message = error.message;
							window.scrollTo(0, 0);
						});
				} else {
					this.size_active = false;
					this.size_error = "Please select a size first";
				}
			},
			select_size: function () {
				this.size_error = "";
				this.qty = "1";
			},
			addtocart(i) {
				if (this.$route.query.popup != true) {
					this.$router.push({ query: { popup: true } });
				}
				this.size_popup = true;
				this.variation = [];
				this.name = this.activerobeproducts[i][1].name;
				this.pro_id = this.activerobeproducts[i][1].id_product;
				this.master_sku = this.activerobeproducts[i][1].sku;
				this.final_price = this.activerobeproducts[i][1].selling_price;
				this.price = this.activerobeproducts[i][1].price;
				this.qty = 1;
				this.variation.push(this.activerobeproducts[i][1].variation);
			},
			size_close() {
				this.size_popup = false;
				this.$router.push({
					query: { popup: "" },
				});
			},
			wardproduct(i) {
				this.activerobeproducts = [];
				this.activerobe = this.wardrobeitem[i][0];
				var robeproducts = Object.entries(this.wardrobeitem[i][1]);
				//this.activerobeproducts =
				for (let i = 0; i < robeproducts.length; i++) {
					if (i == 5) {
						this.activerobeproducts.push([i]);
					}
					this.activerobeproducts.push(robeproducts[i]);
				}
				jQuery("html, body").scrollTop(
					jQuery("#wordrobe-product").offset().top - 300
				);
			},
		},
		created() {
			window.scrollTo(0, 0);
			if (this.$route.query.popup) {
				this.$router.push({
					query: { popup: "" },
				});
			}
			if (screen.width <= 767) {
				this.mobile_view = true;
			}
			if (this.$root.store === 1) {
				this.meta_title = "Trendsette";
				this.meta_description = "Trendsette";
				this.meta_keyword = "Trendsette";
			}
		},
	};
</script>